<mat-form-field appearance="outline" class="package-type-search-field">
  <mat-label>Package Type</mat-label>
  <input
    required
    type="text"
    matInput
    placeholder="Search package types"
    [formControl]="formControl"
    [matAutocomplete]="packageTypeAuto"
    (input)="onSearchInput($event)"
  />
  <mat-autocomplete
    #packageTypeAuto="matAutocomplete"
    [displayWith]="displayPackageType"
    autoActiveFirstOption
    panelClass="medicine-lookup-autocomplete-panel"
  >
    @for (type of packageTypes; track type.id) {
      <mat-option [value]="type">{{ type.type }}</mat-option>
    }
  </mat-autocomplete>
  <mat-icon matPrefix>search</mat-icon>
  <button type="button" matSuffix mat-icon-button (click)="createPackageType($event)">
    <mat-icon>add</mat-icon>
  </button>
  @if (control.invalid && (control.dirty || control.touched)) {
    <mat-error>Package type is invalid</mat-error>
  }
  @if (isSearching) {
    <mat-hint>Searching...</mat-hint>
  }
</mat-form-field>
